<template>
  <div class="markdown-body" v-html="renderedHtml"></div>
</template>

<script>
import { marked } from 'marked';
import DOMPurify from 'dompurify';

marked.setOptions({
  breaks: true,
  gfm: true
});

const FOLLOWUP_HEADER_RE = /(\*\*follow[- ]?up.*?\*\*[:\s]*|📌.*?(?:ask|questions?)[:\s]*|(?:you (?:might|may|could) (?:also )?(?:want to )?ask|suggested questions?|related questions?|here are (?:some )?(?:follow[- ]?up|related|suggested))[:\s]*)/i;

function stripFollowUps(content) {
  if (!content) return content;
  const lines = content.split('\n');
  const idx = lines.findIndex(l => FOLLOWUP_HEADER_RE.test(l.trim()));
  if (idx === -1) return content;
  return lines.slice(0, idx).join('\n').replace(/\n+$/, '');
}

export default {
  name: 'TextRenderer',
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    renderedHtml() {
      if (!this.message.content) return '';
      const cleaned = stripFollowUps(this.message.content);
      const raw = marked(cleaned);
      return DOMPurify.sanitize(raw);
    }
  }
};
</script>

<style scoped>
.markdown-body {
  line-height: 1.6;
  word-wrap: break-word;
}

.markdown-body >>> table {
  border-collapse: collapse;
  width: 100%;
  margin: 8px 0;
  font-size: 0.875rem;
}

.markdown-body >>> th,
.markdown-body >>> td {
  border: 1px solid #dee2e6;
  padding: 6px 10px;
  text-align: left;
}

.markdown-body >>> th {
  background-color: #f1f3f5;
  font-weight: 600;
}

.markdown-body >>> tr:nth-child(even) {
  background-color: #f8f9fa;
}

.markdown-body >>> code {
  background-color: #f1f3f5;
  padding: 2px 4px;
  border-radius: 3px;
  font-size: 0.85em;
}

.markdown-body >>> pre {
  background-color: #f1f3f5;
  padding: 12px;
  border-radius: 4px;
  overflow-x: auto;
}

.markdown-body >>> pre code {
  background: none;
  padding: 0;
}

.markdown-body >>> p {
  margin: 4px 0;
}

.markdown-body >>> ul,
.markdown-body >>> ol {
  padding-left: 20px;
  margin: 4px 0;
}

.markdown-body >>> blockquote {
  border-left: 3px solid #dee2e6;
  padding-left: 12px;
  color: #6c757d;
  margin: 8px 0;
}

.markdown-body >>> h1,
.markdown-body >>> h2,
.markdown-body >>> h3 {
  margin: 8px 0 4px;
}

.markdown-body >>> a {
  color: #0d6efd;
  text-decoration: none;
}

.markdown-body >>> a:hover {
  text-decoration: underline;
}
</style>
